import React from "react";
import TypesReport from "./static.reportsTypes";
import ReportTableResult from "./reportTableResult";
import ReportChartResult from "./reportChartResult";
import ReportTableByDayResult from "./reportTableByDayResult";
import ReportConsolidatedTableResult from "./reportConsolidatedTableResult";
import GeoZoneByDay from "../../ReportTable/GeoZoneByDay/GeoZoneByDay";

const ReportResult = (props) => {
  const { report } = props;

  if (report === null) return null;

  switch (report.reportType) {
    case TypesReport.table.type:
      return (
        <ReportTableResult
          report={report}
          unitId={props.unitId}
          unitsReportData={props.unitsReportData}
          onSetSctollUnitReport={props.onSetSctollUnitReport}
          scrollPositions={props.scrollPositions}
        />
      );

    case TypesReport.chart.type:
      return <ReportChartResult report={report} unitId={props.unitId} unitsReportData={props.unitsReportData} />;

    case TypesReport.tableByDay.type:
      return (
        <ReportTableByDayResult
          report={report}
          unitId={props.unitId}
          unitsReportData={props.unitsReportData}
          onSetSctollUnitReport={props.onSetSctollUnitReport}
          scrollPositions={props.scrollPositions}
        />
      );

    case TypesReport.consolidated.type:
      return <ReportConsolidatedTableResult unitsReportData={props.unitsReportData} />;

    case TypesReport.geoZoneByDay.type:
      return <GeoZoneByDay reportData={props.unitsReportData.reportData} />;

    default:
      return null;
  }
};

export default React.memo(ReportResult);
